import { useMutation } from '@tanstack/react-query';
import { downloadInterestEventsExcel } from '@dealstack/frontend/shared/dataExchange/services/valuations.service';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

interface Args {
	dealId: string | undefined;
	valuationId: string | undefined;
	personId: string | undefined;
	mipId: string | undefined;
	resultId: string | undefined;
}

export function useDownloadInterestEventsExcel({
	dealId,
	valuationId,
	personId,
	mipId,
	resultId,
}: Args) {
	const tDefault = useTranslationDefault();

	const mutation = useMutation({
		mutationFn: async (variables: { securityId: string; trancheKey: string }) => {
			if (!dealId || !valuationId || !personId || !resultId) {
				throw new Error('Missing scope for interest events download');
			}
			await downloadInterestEventsExcel({
				dealId,
				valuationId,
				personId,
				resultId,
				mipId,
				securityId: variables.securityId,
				trancheKey: variables.trancheKey,
				tDefault,
			});
		},
		onError: (error) => {
			if (error instanceof Error && error.message !== 'Download failed') {
				showToastV2({ title: error.message, state: 'error' });
			}
		},
	});

	const isReady = !!dealId && !!valuationId && !!personId && !!resultId;
	return {
		download: mutation.mutate,
		isDownloading: mutation.isPending,
		isReady,
	};
}
